/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-section.get-names.ts 
*/
:host {
  background-color: var(--ace-section-background-color);
  display: block;
  overflow-x: clip;
  overflow-y: visible;
  position: relative;
  width: 100%;
}
:host * {
  box-sizing: border-box;
}

:host([background-src]) {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.ace-section {
  padding-left: var(--ace-section-outer-gutter--mobile, var(--ace-semantic-foundation-spacing-gutter-mobile-outer));
  padding-right: var(--ace-section-outer-gutter--mobile, var(--ace-semantic-foundation-spacing-gutter-mobile-outer));
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  margin: 0 auto;
  max-width: 1600px;
  padding-bottom: var(--ace-section-padding-bottom, var(--ace-primitive-spacing-normal));
  padding-top: var(--ace-section-padding-top, var(--ace-primitive-spacing-normal));
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-section {
    padding-left: var(--ace-section-outer-gutter--tablet, var(--ace-semantic-foundation-spacing-gutter-tablet-outer));
    padding-right: var(--ace-section-outer-gutter--tablet, var(--ace-semantic-foundation-spacing-gutter-tablet-outer));
  }
}
@media only screen and (min-width: 1025px) {
  .ace-section {
    padding-left: var(--ace-section-outer-gutter--desktop, var(--ace-semantic-foundation-spacing-gutter-desktop-outer));
    padding-right: var(--ace-section-outer-gutter--desktop, var(--ace-semantic-foundation-spacing-gutter-desktop-outer));
  }
}
@media only screen and (min-width: calc(1600px + 4rem)) {
  .ace-section {
    padding-left: unset;
    padding-right: unset;
  }
}
.ace-section--with-padding-top {
  padding-top: var(--ace-section-padding-top, var(--ace-primitive-spacing-x-loose));
}
@media only screen and (min-width: 1025px) {
  .ace-section--with-padding-top {
    padding-top: var(--ace-section-padding-top, var(--ace-primitive-spacing-xx-loose));
  }
}
.ace-section--with-padding-bottom {
  padding-bottom: var(--ace-section-padding-bottom, var(--ace-primitive-spacing-x-loose));
}
@media only screen and (min-width: 1025px) {
  .ace-section--with-padding-bottom {
    padding-bottom: var(--ace-section-padding-bottom, var(--ace-primitive-spacing-xx-loose));
  }
}
.ace-section--full-width-mobile {
  padding-left: 0;
  padding-right: 0;
}
@media only screen and (min-width: 595px) {
  .ace-section--full-width-mobile {
    padding-left: var(--ace-section-outer-gutter--mobile, var(--ace-semantic-foundation-spacing-gutter-mobile-outer));
    padding-right: var(--ace-section-outer-gutter--mobile, var(--ace-semantic-foundation-spacing-gutter-mobile-outer));
  }
}
@media only screen and (min-width: 595px) and (min-width: 595px) {
  .ace-section--full-width-mobile {
    padding-left: var(--ace-section-outer-gutter--tablet, var(--ace-semantic-foundation-spacing-gutter-tablet-outer));
    padding-right: var(--ace-section-outer-gutter--tablet, var(--ace-semantic-foundation-spacing-gutter-tablet-outer));
  }
}
@media only screen and (min-width: 595px) and (min-width: 1025px) {
  .ace-section--full-width-mobile {
    padding-left: var(--ace-section-outer-gutter--desktop, var(--ace-semantic-foundation-spacing-gutter-desktop-outer));
    padding-right: var(--ace-section-outer-gutter--desktop, var(--ace-semantic-foundation-spacing-gutter-desktop-outer));
  }
}
@media only screen and (min-width: 595px) and (min-width: calc(1600px + 4rem)) {
  .ace-section--full-width-mobile {
    padding-left: unset;
    padding-right: unset;
  }
}
.ace-section--full-width-tablet {
  padding-left: 0;
  padding-right: 0;
}
@media only screen and (min-width: 1025px) {
  .ace-section--full-width-tablet {
    padding-left: var(--ace-section-outer-gutter--mobile, var(--ace-semantic-foundation-spacing-gutter-mobile-outer));
    padding-right: var(--ace-section-outer-gutter--mobile, var(--ace-semantic-foundation-spacing-gutter-mobile-outer));
  }
}
@media only screen and (min-width: 1025px) and (min-width: 595px) {
  .ace-section--full-width-tablet {
    padding-left: var(--ace-section-outer-gutter--tablet, var(--ace-semantic-foundation-spacing-gutter-tablet-outer));
    padding-right: var(--ace-section-outer-gutter--tablet, var(--ace-semantic-foundation-spacing-gutter-tablet-outer));
  }
}
@media only screen and (min-width: 1025px) and (min-width: 1025px) {
  .ace-section--full-width-tablet {
    padding-left: var(--ace-section-outer-gutter--desktop, var(--ace-semantic-foundation-spacing-gutter-desktop-outer));
    padding-right: var(--ace-section-outer-gutter--desktop, var(--ace-semantic-foundation-spacing-gutter-desktop-outer));
  }
}
@media only screen and (min-width: 1025px) and (min-width: calc(1600px + 4rem)) {
  .ace-section--full-width-tablet {
    padding-left: unset;
    padding-right: unset;
  }
}
.ace-section__header {
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-x-tight);
  width: 100%;
}